import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { axiosPath, path } from "../../../../routing/helpers/router";
import minions from "../../../../minions/minions";
import CommunicationPipelineUserReportAddDefaultTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportAddTemplates/CommunicationPipelineUserReportAddDefaultTemplate";
import CommunicationPipelineUserReportAddHaizeaTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportAddTemplates/CommunicationPipelineUserReportAddHaizeaTemplate";
import CommunicationPipelineUserReportAddCopisaTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportAddTemplates/CommunicationPipelineUserReportAddCopisaTemplate";
import useIsMounted from "../../../../layout/components/hooks/useIsMounted";
import CommunicationPipelineUserReportAddKeyserAndMackayTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportAddTemplates/CommunicationPipelineUserReportAddKeyserAndMackayTemplate";
import errorHandler from "@/layout/components/error/ErrorHandler";
import * as currentPageAction from "@/store/actions/currentPageAction";
import { AppNoInfo } from "@/layout/AppComponents";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";

export default function CommunicationPipelineUserReportAddScreen() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const reportTemplate = useSelector(
    (state) => state.currentPage?.moduleData?.reportTemplate,
  );
  const [reportHex, setReportHex] = useState();
  const moduleData = useSelector((state) => state.currentPage?.moduleData);

  const handleAdd = useCallback(
    async (payload) => {
      axios
        .post(
          axiosPath("api_r_user_module_communicationPipeline_user_report_add"),
          minions.forms.toFormData({ ...payload, moduleBridgeHex }),
          { headers: { "Content-Type": "multipart/form-data" } },
        )
        .then((r) => {
          if (isMounted.current) {
            setReportHex(r?.data?.hex);
          }
        })
        .catch((e) => dispatch(errorHandler(e)));
    },
    [moduleBridgeHex],
  );

  const handleOnFinish = useCallback(() => {
    navigate(
      path({
        name: "user_module_communicationPipeline_home",
        params: { moduleBridgeHex },
      }),
    );
  }, [moduleBridgeHex, reportHex]);

  // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  const renderTemplate = useCallback(() => {
    switch (reportTemplate) {
      case "keyserAndMackay":
        return (
          <CommunicationPipelineUserReportAddKeyserAndMackayTemplate
            reportHex={reportHex}
            onAdd={handleAdd}
            onFinish={handleOnFinish}
          />
        );
      case "haizea":
        return (
          <CommunicationPipelineUserReportAddHaizeaTemplate
            reportHex={reportHex}
            onAdd={handleAdd}
            onFinish={handleOnFinish}
          />
        );
      case "copisa":
        return (
          <CommunicationPipelineUserReportAddCopisaTemplate
            reportHex={reportHex}
            onAdd={handleAdd}
            onFinish={handleOnFinish}
          />
        );
      default:
        return (
          <CommunicationPipelineUserReportAddDefaultTemplate
            reportHex={reportHex}
            onAdd={handleAdd}
            onFinish={handleOnFinish}
          />
        );
    }
  }, [reportTemplate, reportHex, handleAdd, handleOnFinish]);

  if (!moduleData) return <AppNoInfo />;

  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      <Container>{renderTemplate()}</Container>
    </>
  );
}

const Container = styled.div`
  padding-left: 0.5rem !important;
  padding-bottom: 100px;

  h3 {
    font-size: 14px;
    font-weight: 700;
    margin: 32px 0 0 0;
  }
  .minHeight600 {
    min-height: 600px;
  }
  .user-info {
    border: 1px solid lightgray;
    padding: 24px;
  }
`;
